import { render, staticRenderFns } from "./MasterPromo.vue?vue&type=template&id=54e76944&"
import script from "./MasterPromo.vue?vue&type=script&lang=js&"
export * from "./MasterPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports